import React from "react";
import { Helmet } from "react-helmet-async";
import { NavLink } from "react-router-dom";

interface Seo {
    pageTitle: string;
    metaDescription: string;
    keyWords: string;
}

interface Img {
    src: string;
    alt: string;
}

export default class Insight {
    heading: string = "";
    date: string;
    seo: Seo;
    img: Img;
    title: string;
    sub: string;
    preview: string;
    jsx: React.ReactNode;

    constructor(date: string, seo: Seo, img: Img, title: string, sub: string, preview: string, jsx: React.ReactNode) {
        this.date = date;
        this.seo = seo;
        this.title = title;
        this.img = img;
        this.sub = sub;
        this.preview = preview;
        this.jsx = jsx;
    }

    get InsightJSX() {
        return (
            <div className="insight-page-container" onLoad={() => { window.scrollTo(0, 0); }}>
                <Helmet>
                    <meta name="description" content={this.seo.metaDescription} />
                    <meta name="keywords" content={this.seo.keyWords} />
                </Helmet>
                {this.jsx}
            </div>
        );
    }

    get previewJSX() {
        return (
            <NavLink to={`/insights/${this.title.toLowerCase().split(" ").join("-").replace("!", "").replace("(", "").replace(")", "")}`} target="_blank" className="insight-container">
                <img src={this.img.src} alt={this.img.alt} style={{ objectFit: "cover", objectPosition: "left" }} />
                <div>
                    {this.heading === "h2"
                        ? <h2>{this.title}</h2>
                        : this.heading === "h3" && <h3>{this.title}</h3>
                    }
                    <p className="sub">{this.sub}</p>
                    <p style={{ marginBottom: "30px", opacity: "0.4" }}>{this.date}</p>
                    <p className="preview">{this.preview}</p>
                </div>
            </NavLink>
        );
    }

    get smallPreviewJSX() {
        return (
            <NavLink className="inline-flex flex-col gap-2" to={`/insights/${this.title.toLowerCase().split(" ").join("-").replace("!", "").replace("(", "").replace(")", "")}`} target="_blank">
                <img className="w-[300px] h-[200px]" src={this.img.src} alt={this.img.alt} style={{ objectFit: "cover", objectPosition: "left" }} />
                <div className="w-[300px]">
                    {this.heading === "h2"
                        ? <h2 className="text-main">{this.title}</h2>
                        : this.heading === "h3" && <h3 className="text-main">{this.title}</h3>
                    }
                    <p className="text-sm text-gray-600">{this.sub}</p>
                    <p className="mb-4 text-gray-300 text-sm">{this.date}</p>
                    <p className="text-sm text-gray-700">{this.preview}</p>
                </div>
            </NavLink>
        );
    }
}
